import React, { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { StyleSheet } from 'react-native';
import { Typography } from '@packages/ui/shared';
import colors from '@packages/core/styles/colors';

const useStyles = createUseStyles({
    container: {
        borderBottom: `1px solid ${colors.grayThree}`,
        padding: '24px 32px 0px',
        height: 64,
    },
    cursorPointer: {
        cursor: 'pointer',
    },
});

const styles = StyleSheet.create({
    tab: {
        alignSelf: 'flex-start',
        color: colors.grayFive,
        fontSize: 15,
        fontWeight: '600',
        lineHeight: 24,
        borderBottomWidth: 2,
        borderBottomColor: 'transparent',
        paddingBottom: 16,
    },
    selectedTab: {
        color: colors.blueOne,
        borderBottomColor: colors.blueOne,
    },
});

const TabComponent: FC<any> = ({ label, value, currentStatus, onClick }) => {
    const classes = useStyles();

    return (
        <div onClick={() => onClick(value)} className={`${classes.cursorPointer} d-flex`}>
            <Typography
                style={currentStatus === value ? { ...styles.tab, ...styles.selectedTab } : styles.tab}
                color="grayFive"
                variant="h6"
                numberOfLines={1}
                ellipsizeMode="tail"
            >
                {label}
            </Typography>
        </div>
    );
};

export const StatusTabs: FC<any> = ({ currentStatusFilter, setCurrentStatusFilter, setPageIndex, showDraftCases }) => {
    const classes = useStyles();
    const tabs = [
        { label: 'All', value: 'ALL' },
        showDraftCases && { label: 'Draft', value: 'DRAFT' },
        { label: 'In Review', value: 'IN_REVIEW' },
        { label: 'Update Requested', value: 'UPDATE_REQUESTED' },
        { label: 'Pending Techline', value: 'PENDING_TECHLINE' },
        { label: 'Closed', value: 'CLOSED' },
    ].filter(Boolean);

    const handleTabClick = (value: string) => {
        setPageIndex(0);
        setCurrentStatusFilter(value);
    };

    return (
        <div className={`d-flex gap-4 ${classes.container}`}>
            {tabs.map((tab) => (
                <TabComponent
                    currentStatus={currentStatusFilter}
                    key={tab.value}
                    label={tab.label}
                    onClick={handleTabClick}
                    value={tab.value}
                />
            ))}
        </div>
    );
};
